"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterAppSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = require("@ori/testid-generator");
var _styles = require("../../components/FollowUs/styles");
var _styles2 = require("../../components/styles");
var _constantsGenerated = require("../../constants-generated");
var _styles3 = require("../FooterContent/styles");
var _components = require("./components");
var _styles4 = require("./components/LinkColumn/styles");
var _styles5 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Footer app skeleton for when the footer is no longer served via SSR but rendered only via CSR
 */
const FooterAppSkeleton = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
  team: _testidGenerator.Team.Presentation,
  project: _constantsGenerated.APP_NAME,
  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles3.Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles5.SubscribeBannerRoot, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.UnifiedSkeleton, {
        height: 27,
        width: 400
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.Highlight, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles3.HighlightGrid, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles5.LinksRoot, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles5.MobileLinks, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles4.MobileLinkColumn, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles4.MobileLinkColumn, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles4.MobileLinkColumn, {})]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles5.DesktopLinks, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.LinkColumn, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.LinkColumn, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.LinkColumn, {})]
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles3.FourthColumn, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.MobileAppsColumn, {})
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles3.BottomContent, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.FollowUsRoot, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          component: "p",
          variant: "h6",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.UnifiedSkeleton, {
            width: 85
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.UnifiedSkeleton, {
          width: 200,
          height: 34
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.MobileAppsColumn, {
        hideOnDesktop: true
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles5.CopyrightRoot, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.UnifiedSkeleton, {
          width: 340,
          height: 40
        })
      })]
    })]
  })
});
exports.FooterAppSkeleton = FooterAppSkeleton;
